// Generated types for PartUsage
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLUsageReadAPI, SysMLUsageWriteAPI } from './sysmlusage';
import { SysMLUsageReadAPISchemaObject, SysMLUsageWriteAPISchemaObject } from './sysmlusage';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PartUsageReadAPI extends SysMLUsageReadAPI {
}

export interface PartUsageWriteAPI extends SysMLUsageWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PartUsageReadAPISchema: z.ZodType<PartUsageReadAPI> = SysMLUsageReadAPISchemaObject.extend({}).passthrough();

export const PartUsageWriteAPISchema: z.ZodType<PartUsageWriteAPI> = SysMLUsageWriteAPISchemaObject.extend({}).passthrough();
